// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { MenuList } from '../../../components'
import { isInventoryOwnedWorkspace } from '../../../utils/feature-flag-utils'
import {
  getWorkspaceString,
  WKSPC_CAPITALIZED
} from '../../../utils/common-utils'

const HPEGLAdministrationMenu = () => {
  const { t } = useTranslation(['common'])
  const navigate = useNavigate()
  const LDFlags = useFlags()
  const showWorkspaceString = LDFlags['glcp-switch-to-workspace']

  const handleHPEGLAdministrationMenuItemClick = (item) => {
    if (item.linkTo.includes('http')) {
      window.open(item.linkTo, '_blank')
    } else {
      navigate(item.linkTo)
    }
  }

  return (
    <MenuList
      navStyles={{
        padding: 'none',
        gap: 'none'
      }}
      menuData={[
        {
          id: 1,
          label: t('app_navigation.manage_account', {
            account: getWorkspaceString(
              showWorkspaceString,
              t,
              WKSPC_CAPITALIZED
            )
          }),
          linkTo: '/manage-account',
          testId: 'header-apps-manage-account'
        },
        {
          id: 2,
          label: t('app_navigation.manage_devices'),
          linkTo: '/devices/inventory',
          testId: 'header-apps-manage-devices',
          isHidden: () => !isInventoryOwnedWorkspace()
        }
      ]}
      onClickMenuItem={handleHPEGLAdministrationMenuItemClick}
      testId="hpe-gl-administration-menu"
    />
  )
}

export { HPEGLAdministrationMenu }
